import Vue from 'vue';

import { BAlert } from 'bootstrap-vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faQuestionCircle);

Vue.use(BootstrapVue);

Vue.component('b-alert', BAlert);
Vue.component('font-awesome-icon', FontAwesomeIcon);
